import { render } from "./bankrate-footer.vue?vue&type=template&id=be5974d8"
import script from "./bankrate-footer.js?vue&type=script&lang=js"
export * from "./bankrate-footer.js?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__